<template>
  <v-dialog v-model="showPopup" lazy scrollable max-width="70%">
    <v-card>
      <v-card-title class="headline">{{$t(titlePath)}}</v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <span v-html="$t(bodyPath, version)"></span>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat @click.native="$emit('close')">
          <span v-html="$t('questionnaire.itemHelpDialog.CLOSE_BUTTON')"></span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'description-popup',
    props: ['version', 'titlePath', 'bodyPath', 'showPopup'],
    data () {
      return {
        dialogHelp: false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/questionnaires/descriptionPopup.vue